import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function AskEntryCard() {
  const navigate = useNavigate();
  return (
    <button
      data-testid="ask-entry-banner"
      onClick={() => navigate("/asks")}
      className="group mt-3 w-full overflow-hidden rounded-3xl bg-primary text-left text-primary-foreground relative px-5 py-4 transition-transform active:scale-[0.98]"
    >
      <div className="pointer-events-none absolute -right-6 -top-10 h-36 w-36 rounded-full bg-accent/30 blur-2xl" />
      <img src="/ask/gift.webp" alt="" className="pointer-events-none absolute right-2 -bottom-3 h-24 w-24 object-contain ask-float" />
      <p className="relative text-[11px] font-bold uppercase tracking-[0.14em] text-accent">New · Debii Ask</p>
      <p className="relative mt-1 font-display text-lg font-extrabold leading-tight">Need a little help?</p>
      <p className="relative mt-0.5 flex items-center gap-1 text-xs text-primary-foreground/80">
        Gift Me or Lend Me <ChevronRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
      </p>
    </button>
  );
}
